import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Purpose_Other_getInstancerlegdjt2kagb as Purpose_Other_getInstance,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../nav/AppDimensions.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { compareBy2697bq0ffft96 as compareBy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { renderAttachment65kt96l4h4c9 as renderAttachment } from './renderFiles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../../theming/appTheme.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance } from '../../theming/Titles.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { get_edit2tiiawv2658bs as get_edit } from '../../../icons.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  asyncz02dsa2nb2zt as async,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from './fileManager.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  RemoteAttachment3uyi4s0lht7h0 as RemoteAttachment,
  FileDataw8niis0ucpno as FileData,
  resolveContractorDocumentsg17i59nppbn3 as resolveContractorDocuments,
} from './attachmentFilePreview.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  coroutineScope284yy3flyb2v2 as coroutineScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { CoroutineStart_LAZY_getInstance3nocrha1i30z1 as CoroutineStart_LAZY_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_name70kb37c3pbx4 as get_name,
  get_fileType1vl9fun22hvs1 as get_fileType,
  get_file3rh777rh5vwaj as get_file,
  get_preview1fun5m2mrxd65 as get_preview,
} from '../../../../../../crowpay-shared/com/crowpay/ContractorDocumentFields.mjs';
import {
  ServerFile1t91jzpzoixwe as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderContractorDocuments(_this__u8e3s4, render, mimeTypes, purpose, size, localFiles) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  purpose = purpose === VOID ? Purpose_Other_getInstance() : purpose;
  size = size === VOID ? get_AppDimensions().qg2_1 : size;
  localFiles = localFiles === VOID ? Signal().fak(emptyList()) : localFiles;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  var editingDocuments = mutableRemember(VOID, VOID, ($this$mutableRemember) => $this$mutableRemember.baj(render).i1());
  var tmp = shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.baj(editingDocuments));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var tmp_0 = view_0.ibb(shownWhen(view_0, true, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.baj(render).i1();
  }), get_scrollingHorizontally(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  var sorted = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.baj(render);
    var tmp_0 = renderContractorDocuments$lambda$lambda;
    return sortedWith(tmp, compareBy([tmp_0, renderContractorDocuments$lambda$lambda_0]));
  });
  forEachUpdating(view_1, sorted, VOID, ($this$forEachUpdating, attachment) => {
    $this$forEachUpdating.jbb(get_centered($this$forEachUpdating), renderAttachment($this$forEachUpdating, attachment, sorted, size));
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp_0, view_1);
  var tmp_1 = view_0.ibb(shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(render).i1()), view_0.hbb(NothingHereSemantic_getInstance()));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.jba(view_2.ob6_1.ybe(SubtitleSemantic_getInstance()));
  view_2.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'No Documents uploaded';
  var tmp_2 = view_2.tb5_1;
  var tmp_3;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_3 = '\xA0';
  } else {
    tmp_3 = value;
  }
  tmp_2.fbu(tmp_3);
  view_0.fbb(p_2, view_2);
  view_0.jbb(tmp_1, view_2);
  var tmp_4 = view_0.ibb(align(view_0, Align_End_getInstance(), Align_Center_getInstance()), get_tertiaryButton(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_0.pc());
  var tmp0_elvis_lhs_3 = view_0.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
  view_0.ebb(p_3, view_3);
  icon(view_3, get_edit(Companion_getInstance()), 'Edit Documents');
  onClick(view_3, VOID, VOID, renderContractorDocuments$slambda_0(editingDocuments));
  view_0.fbb(p_3, view_3);
  view_0.jbb(tmp_4, view_3);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  var tmp_5 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(editingDocuments));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.ebb(p_4, view_4);
  view_4.xbm(true);
  launch(view_4, VOID, VOID, renderContractorDocuments$slambda_2(localFiles, render));
  fileManager(view_4, localFiles, 'No Documents Uploaded', mimeTypes, size, renderContractorDocuments$slambda_4());
  var tmp_6 = align(view_4, Align_End_getInstance(), Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.cbb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.ebb(p_5, view_5);
  view_5.xbm(false);
  view_5.zb8(get_AppDimensions().ig2_1);
  var tmp_7 = get_textButton(view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (Button())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.ebb(p_6, view_6);
  specCenteredText(view_6, 'Cancel');
  onClick(view_6, VOID, VOID, renderContractorDocuments$slambda_6(editingDocuments, localFiles, render));
  view_5.fbb(p_6, view_6);
  view_5.jbb(tmp_7, view_6);
  var tmp_8 = get_tertiaryButton(view_5);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Button())(view_5.pc());
  var tmp0_elvis_lhs_7 = view_5.cbb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
  view_5.ebb(p_7, view_7);
  specCenteredText(view_7, 'Save');
  onClick(view_7, VOID, VOID, renderContractorDocuments$slambda_8(localFiles, render, editingDocuments, purpose));
  view_5.fbb(p_7, view_7);
  view_5.jbb(tmp_8, view_7);
  view_4.fbb(p_5, view_5);
  view_4.jbb(tmp_6, view_5);
  view.fbb(p_4, view_4);
  view.jbb(tmp_5, view_4);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function *_generator_renderContractorDocuments$_anonymous_$_anonymous_$reset__k5g6ju($localFiles, $render, $completion) {
  var tmp = await_0($render, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = new (FileData())(item.d5h_1, Signal().fak(item.f5h_1), new (RemoteAttachment())(item), new (RemoteAttachment())(item));
    destination.v(tmp$ret$0);
  }
  var tmp_0 = $localFiles.gah(destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function renderContractorDocuments$_anonymous_$_anonymous_$reset_mvu7uy($localFiles, $render, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_renderContractorDocuments$_anonymous_$_anonymous_$reset__k5g6ju.bind(VOID, $localFiles, $render), $completion);
}
function renderContractorDocuments$lambda$lambda(it) {
  return it.f5h_1;
}
function renderContractorDocuments$lambda$lambda_0(it) {
  return it.d5h_1;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.ggc_1.gah(true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderContractorDocuments$slambdaClass;
function renderContractorDocuments$slambda() {
  if (renderContractorDocuments$slambdaClass === VOID) {
    class $ {
      constructor($editingDocuments) {
        this.ggc_1 = $editingDocuments;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorDocuments$slambdaClass = $;
  }
  return renderContractorDocuments$slambdaClass;
}
function renderContractorDocuments$slambda_0($editingDocuments) {
  var i = new (renderContractorDocuments$slambda())($editingDocuments);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = renderContractorDocuments$_anonymous_$_anonymous_$reset_mvu7uy($this.hgc_1, $this.igc_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var renderContractorDocuments$slambdaClass_0;
function renderContractorDocuments$slambda_1() {
  if (renderContractorDocuments$slambdaClass_0 === VOID) {
    class $ {
      constructor($localFiles, $render) {
        this.hgc_1 = $localFiles;
        this.igc_1 = $render;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorDocuments$slambdaClass_0 = $;
  }
  return renderContractorDocuments$slambdaClass_0;
}
function renderContractorDocuments$slambda_2($localFiles, $render) {
  var i = new (renderContractorDocuments$slambda_1())($localFiles, $render);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().mff_1);
}
var LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.jgc_1 = p0;
      }
      sao($completion) {
        return this.jgc_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2ContractorLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2ContractorLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2ContractorLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
var renderContractorDocuments$slambdaClass_1;
function renderContractorDocuments$slambda_3() {
  if (renderContractorDocuments$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorDocuments$slambdaClass_1 = $;
  }
  return renderContractorDocuments$slambdaClass_1;
}
function renderContractorDocuments$slambda_4() {
  var i = new (renderContractorDocuments$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.kgc_1.gah(false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = renderContractorDocuments$_anonymous_$_anonymous_$reset_mvu7uy($this.lgc_1, $this.mgc_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var renderContractorDocuments$slambdaClass_2;
function renderContractorDocuments$slambda_5() {
  if (renderContractorDocuments$slambdaClass_2 === VOID) {
    class $ {
      constructor($editingDocuments, $localFiles, $render) {
        this.kgc_1 = $editingDocuments;
        this.lgc_1 = $localFiles;
        this.mgc_1 = $render;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorDocuments$slambdaClass_2 = $;
  }
  return renderContractorDocuments$slambdaClass_2;
}
function renderContractorDocuments$slambda_6($editingDocuments, $localFiles, $render) {
  var i = new (renderContractorDocuments$slambda_5())($editingDocuments, $localFiles, $render);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfv_1;
  // Inline function 'kotlin.collections.map' call
  var this_1 = $this.ngc_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.l5h(VOID, VOID, VOID, VOID, VOID, VOID, $this.ogc_1);
    destination.v(tmp$ret$1);
  }
  var tmp_1 = tmp_0.aeo(destination, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return tmp_1;
}
function *_generator_invoke__zhh2q8_4($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfv_1.eeo($this.pgc_1.d5h_1).iem($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.kfv_1.eeo($this.qgc_1.d5h_1).len($this.rgc_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var renderContractorDocuments$slambda$slambda$slambdaClass;
function renderContractorDocuments$slambda$slambda$slambda() {
  if (renderContractorDocuments$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($newDocuments, $purpose) {
        this.ngc_1 = $newDocuments;
        this.ogc_1 = $purpose;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorDocuments$slambda$slambda$slambdaClass = $;
  }
  return renderContractorDocuments$slambda$slambda$slambdaClass;
}
function renderContractorDocuments$slambda$slambda$slambda_0($newDocuments, $purpose) {
  var i = new (renderContractorDocuments$slambda$slambda$slambda())($newDocuments, $purpose);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var renderContractorDocuments$slambda$slambda$slambdaClass_0;
function renderContractorDocuments$slambda$slambda$slambda_1() {
  if (renderContractorDocuments$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($doc) {
        this.pgc_1 = $doc;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorDocuments$slambda$slambda$slambdaClass_0 = $;
  }
  return renderContractorDocuments$slambda$slambda$slambdaClass_0;
}
function renderContractorDocuments$slambda$slambda$slambda_2($doc) {
  var i = new (renderContractorDocuments$slambda$slambda$slambda_1())($doc);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var renderContractorDocuments$slambda$slambda$slambdaClass_1;
function renderContractorDocuments$slambda$slambda$slambda_3() {
  if (renderContractorDocuments$slambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($og, $mods) {
        this.qgc_1 = $og;
        this.rgc_1 = $mods;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorDocuments$slambda$slambda$slambdaClass_1 = $;
  }
  return renderContractorDocuments$slambda$slambda$slambdaClass_1;
}
function renderContractorDocuments$slambda$slambda$slambda_4($og, $mods) {
  var i = new (renderContractorDocuments$slambda$slambda$slambda_3())($og, $mods);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0 = await_0($this.sgc_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = resolveContractorDocuments(tmp_0, c, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var updatedDocuments = tmp_1;
  var tmp_2 = await_0($this.tgc_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var originalDocuments = tmp_2;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = updatedDocuments.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_3;
      if (isInterface(originalDocuments, Collection())) {
        tmp_3 = originalDocuments.i1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$1 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = originalDocuments.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.d5h_1.equals(element.d5h_1)) {
          tmp$ret$1 = false;
          break $l$block_0;
        }
      }
      tmp$ret$1 = true;
    }
    if (tmp$ret$1) {
      destination.v(element);
    }
  }
  var newDocuments = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = updatedDocuments.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$7;
    $l$block_1: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_2 = originalDocuments.m1();
      while (_iterator__ex2g4s_2.n1()) {
        var element_2 = _iterator__ex2g4s_2.o1();
        if (element_2.d5h_1.equals(element_1.d5h_1)) {
          tmp$ret$7 = element_2;
          break $l$block_1;
        }
      }
      tmp$ret$7 = null;
    }
    var tmp0_safe_receiver = tmp$ret$7;
    var tmp_4;
    if (tmp0_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_4 = to(tmp0_safe_receiver, element_1);
    }
    var tmp0_safe_receiver_0 = tmp_4;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.v(tmp0_safe_receiver_0);
    }
  }
  var modified = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList().w();
  var _iterator__ex2g4s_3 = originalDocuments.m1();
  while (_iterator__ex2g4s_3.n1()) {
    var element_3 = _iterator__ex2g4s_3.o1();
    var tmp$ret$18;
    $l$block_3: {
      // Inline function 'kotlin.collections.none' call
      var tmp_5;
      if (isInterface(updatedDocuments, Collection())) {
        tmp_5 = updatedDocuments.i1();
      } else {
        tmp_5 = false;
      }
      if (tmp_5) {
        tmp$ret$18 = true;
        break $l$block_3;
      }
      var _iterator__ex2g4s_4 = updatedDocuments.m1();
      while (_iterator__ex2g4s_4.n1()) {
        var element_4 = _iterator__ex2g4s_4.o1();
        if (element_3.d5h_1.equals(element_4.d5h_1)) {
          tmp$ret$18 = false;
          break $l$block_3;
        }
      }
      tmp$ret$18 = true;
    }
    if (tmp$ret$18) {
      destination_1.v(element_3);
    }
  }
  var deleted = destination_1;
  var tmp_6 = coroutineScope(renderContractorDocuments$slambda$slambda_0(newDocuments, deleted, modified, $this.vgc_1), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var tmp_7 = $this.ugc_1.gah(false, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var tmp_8 = renderContractorDocuments$_anonymous_$_anonymous_$reset_mvu7uy($this.sgc_1, $this.tgc_1, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  return Unit_instance;
}
var renderContractorDocuments$slambda$slambdaClass;
function renderContractorDocuments$slambda$slambda() {
  if (renderContractorDocuments$slambda$slambdaClass === VOID) {
    class $ {
      constructor($newDocuments, $deleted, $modified, $purpose) {
        this.wgc_1 = $newDocuments;
        this.xgc_1 = $deleted;
        this.ygc_1 = $modified;
        this.zgc_1 = $purpose;
      }
      wah($this$coroutineScope, $completion) {
        // Inline function 'kotlin.collections.buildList' call
        // Inline function 'kotlin.collections.buildListInternal' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().w();
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.wgc_1.i1()) {
          var tmp = CoroutineStart_LAZY_getInstance();
          this_0.v(async($this$coroutineScope, VOID, tmp, renderContractorDocuments$slambda$slambda$slambda_0(this.wgc_1, this.zgc_1)));
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.xgc_1.i1()) {
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.xgc_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp_0 = CoroutineStart_LAZY_getInstance();
            this_0.v(async($this$coroutineScope, VOID, tmp_0, renderContractorDocuments$slambda$slambda$slambda_2(element)));
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.ygc_1.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          var og = element_0.cf();
          var updated = element_0.df();
          // Inline function 'com.lightningkite.lightningdb.modification' call
          // Inline function 'kotlin.apply' call
          var this_1 = new (ModificationBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(ContractorDocument()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$4);
          if (!(og.f5h_1 === updated.f5h_1)) {
            this_1.e44(get_name(it), updated.f5h_1);
          }
          if (!(og.g5h_1 === updated.g5h_1)) {
            this_1.e44(get_fileType(it), updated.g5h_1);
          }
          if (!(substringBefore(_ServerFile___get_location__impl__ddyqaq(og.h5h_1), _Char___init__impl__6a9atx(63)) === substringBefore(_ServerFile___get_location__impl__ddyqaq(updated.h5h_1), _Char___init__impl__6a9atx(63)))) {
            this_1.e44(get_file(it), new (ServerFile())(updated.h5h_1));
          }
          var tmp0_safe_receiver = og.i5h_1;
          var tmp_2;
          var tmp_3 = tmp0_safe_receiver;
          if ((tmp_3 == null ? null : new (ServerFile())(tmp_3)) == null) {
            tmp_2 = null;
          } else {
            tmp_2 = _ServerFile___get_location__impl__ddyqaq(tmp0_safe_receiver);
          }
          var tmp1_safe_receiver = tmp_2;
          var tmp_4 = tmp1_safe_receiver == null ? null : substringBefore(tmp1_safe_receiver, _Char___init__impl__6a9atx(63));
          var tmp2_safe_receiver = updated.i5h_1;
          var tmp_5;
          var tmp_6 = tmp2_safe_receiver;
          if ((tmp_6 == null ? null : new (ServerFile())(tmp_6)) == null) {
            tmp_5 = null;
          } else {
            tmp_5 = _ServerFile___get_location__impl__ddyqaq(tmp2_safe_receiver);
          }
          var tmp3_safe_receiver = tmp_5;
          if (!(tmp_4 == (tmp3_safe_receiver == null ? null : substringBefore(tmp3_safe_receiver, _Char___init__impl__6a9atx(63))))) {
            var tmp_7 = get_preview(it);
            var tmp_8 = updated.i5h_1;
            this_1.e44(tmp_7, tmp_8 == null ? null : new (ServerFile())(tmp_8));
          }
          var mods = this_1.o1r();
          if (!mods.h42()) {
            var tmp_9 = CoroutineStart_LAZY_getInstance();
            this_0.v(async($this$coroutineScope, VOID, tmp_9, renderContractorDocuments$slambda$slambda$slambda_4(og, mods)));
          }
        }
        var calls = this_0.c8();
        return awaitAll(calls, $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    renderContractorDocuments$slambda$slambdaClass = $;
  }
  return renderContractorDocuments$slambda$slambdaClass;
}
function renderContractorDocuments$slambda$slambda_0($newDocuments, $deleted, $modified, $purpose) {
  var i = new (renderContractorDocuments$slambda$slambda())($newDocuments, $deleted, $modified, $purpose);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
var renderContractorDocuments$slambdaClass_3;
function renderContractorDocuments$slambda_7() {
  if (renderContractorDocuments$slambdaClass_3 === VOID) {
    class $ {
      constructor($localFiles, $render, $editingDocuments, $purpose) {
        this.sgc_1 = $localFiles;
        this.tgc_1 = $render;
        this.ugc_1 = $editingDocuments;
        this.vgc_1 = $purpose;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    renderContractorDocuments$slambdaClass_3 = $;
  }
  return renderContractorDocuments$slambdaClass_3;
}
function renderContractorDocuments$slambda_8($localFiles, $render, $editingDocuments, $purpose) {
  var i = new (renderContractorDocuments$slambda_7())($localFiles, $render, $editingDocuments, $purpose);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  renderContractorDocuments as renderContractorDocuments200vd6dka4jio,
};
//endregion

//# sourceMappingURL=contractorDocuments.mjs.map
